import { render, staticRenderFns } from "./FavoriteGroupList.vue?vue&type=template&id=72be1f3a&scoped=true&"
import script from "./FavoriteGroupList.vue?vue&type=script&lang=js&"
export * from "./FavoriteGroupList.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteGroupList.vue?vue&type=style&index=0&id=72be1f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be1f3a",
  null
  
)

export default component.exports